import { Flex, Paper } from "@pillar-ui/core";
import "@pillar-ui/core/main.css";
import Header from "./components/header";
import {
  AppStateContext,
  CreateNewStateContext,
  FilterStateContext,
  SortingStateContext,
} from "./common/contexts";
import { useState } from "react";
import {
  PAGE,
  RESTAURANT_TYPE,
  SORT_BY_AZ,
  SORT_BY_DISTANCE,
  SORT_BY_PRICE,
  SORT_TYPE,
} from "./common/constants";
import Toolbar from "./components/toolbar";
import Sortings from "./components/sortings";
import RestaurantList from "./components/restaurant-list";
import RestaurantEditor from "./components/restaurant-editor";
import { APP_MAX_WIDTH } from "./styles/variables";
import Toast from "./components/toast";
import Carousel from "./components/carousel";
import CommentEditor from "./components/comment-editor";
import SpinningWheel from "./components/spinning-wheel";
import { useRestaurant } from "./hooks/use-restaurant";
import DrinkingWheel from "./components/drinking-wheel";
import spinningWheelImg from "./assets/icons/spinning-wheel.png";
import LuckyGames from "./containers/lucky-games";

const App = () => {
  const [filterByName, setFilterByName] = useState();
  const [filterByType, setFilterByType] = useState(RESTAURANT_TYPE.ALL);
  const [filterById, setFilterById] = useState();
  const [sortByAZ, setSortByAZ] = useState(SORT_BY_AZ.ASCENDING);
  const [sortByDistance, setSortByDistance] = useState(
    SORT_BY_DISTANCE.NEAREST
  );
  const [sortByPrice, setSortByPrice] = useState(SORT_BY_PRICE.ASCENDING);
  const [restaurantList, setRestaurantList] = useState([]);
  const [totalLength, setTotalLength] = useState();
  const [focusSortType, setFocusSortType] = useState(SORT_TYPE.AZ);
  const [isOpenRestaurantEditor, setIsOpenRestaurantEditor] = useState(false);
  const [restaurantEditorData, setRestaurantEditorData] = useState(null);
  const [toastVisible, setToastVisible] = useState(false);
  const [toastType, setToastType] = useState();
  const [toastMsg, setToastMsg] = useState();
  const [isOpenCommentEditor, setIsOpenCommentEditor] = useState(false);
  const [commentList, setCommentList] = useState([]);
  const [commentEditorData, setCommentEditorData] = useState(null);
  const [page, setPage] = useState(PAGE.RESTAURANT);

  const handleOpenToast = (type, message) => {
    setToastType(type);
    setToastMsg(message);
    setToastVisible(true);
  };

  useRestaurant({
    filterById,
    filterByName,
    filterByType,
    focusSortType,
    restaurantList,
    setRestaurantList,
    setTotalLength,
    sortByAZ,
    sortByDistance,
    sortByPrice,
  });

  return (
    <AppStateContext.Provider
      value={{
        restaurantList,
        setRestaurantList,
        isOpenRestaurantEditor,
        setIsOpenRestaurantEditor,
        handleOpenToast,
        totalLength,
        setTotalLength,
        isOpenCommentEditor,
        setIsOpenCommentEditor,
        commentList,
        setCommentList,
      }}
    >
      <CreateNewStateContext.Provider
        value={{ setRestaurantEditorData, setCommentEditorData }}
      >
        <FilterStateContext.Provider
          value={{
            filterById,
            filterByName,
            filterByType,
            setFilterById,
            setFilterByName,
            setFilterByType,
          }}
        >
          <SortingStateContext.Provider
            value={{
              focusSortType,
              sortByAZ,
              sortByDistance,
              sortByPrice,
              setFocusSortType,
              setSortByAZ,
              setSortByDistance,
              setSortByPrice,
            }}
          >
            <Flex justify="center">
              <Paper
                className="overflow-x-hidden"
                corner="0"
                height="100vh"
                width="100vw"
                background="Se5"
                style={{
                  overflowY: "scroll",
                  scrollbarWidth: "none", // Firefox
                  msOverflowStyle: "none", // IE, Edge
                  maxWidth: APP_MAX_WIDTH,
                }}
              >
                <Header />
                <Carousel />
                <Toolbar currentPage={page} setPage={setPage} />
                {page === PAGE.LUCKY_GAMES && <LuckyGames />}
                {page === PAGE.RESTAURANT && (
                  <>
                    <Sortings />
                    <RestaurantList />
                  </>
                )}
              </Paper>
            </Flex>
            {page !== PAGE.LUCKY_GAMES && (
              <Paper onClick={() => setPage(PAGE.LUCKY_GAMES)}>
                <img
                  src={spinningWheelImg}
                  width="40%"
                  alt={spinningWheelImg}
                  style={{
                    position: "fixed",
                    bottom: 0,
                    right: 0,
                    maxWidth: 200,
                  }}
                />
              </Paper>
            )}
            <RestaurantEditor
              open={isOpenRestaurantEditor}
              onClose={() => setIsOpenRestaurantEditor(false)}
              restaurantEditorData={restaurantEditorData}
            />
            <CommentEditor
              open={isOpenCommentEditor}
              onClose={() => setIsOpenCommentEditor(false)}
              commentEditorData={commentEditorData}
              commentList={commentList}
            />
            <Toast
              open={toastVisible}
              message={toastMsg}
              onClose={() => setToastVisible(false)}
              variant={toastType}
            />
          </SortingStateContext.Provider>
        </FilterStateContext.Provider>
      </CreateNewStateContext.Provider>
    </AppStateContext.Provider>
  );
};

export default App;
